import { observer } from 'mobx-react';
import ImportParticipantsStore from '../../Store';
import { ViewReportAction } from '../../Store/Types';
import { T, TPlainTextKey } from '../../../../../Translations';

interface Props {
  store: ImportParticipantsStore;
  status: ViewReportAction;
  text: TPlainTextKey;
}

function ViewReport({ store, status }: Props) {
  return (
    <a onClick={() => store.viewReport(status)} className="cursor-pointer text-teal-600">
      <T kind="View all details" />
    </a>
  );
}

export default observer(ViewReport);
